module.exports = __webpack_public_path__ + "img/steung-meanchey-branch.fc4d4749.jpg";